module.exports = __webpack_public_path__ + "img/article_11_1.46c41ac9.webp";